import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/linebaccounts.scss";

export default function LineBAccountDetail() {
  const { account } = useParams();
  const navigate = useNavigate();
  const [accountData, setAccountData] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [visited, setVisited] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const fetchAccount = async () => {
    try {
      const res = await fetch(`/api/singlelinebaccounts/${account}`);
      const data = await res.json();
      setAccountData(data.data[0]);
      setRemarks(data.data[0].remarks || "");
      setVisited(data.data[0].visited);
    } catch (err) {
      setError("Failed to load account");
    }
  };

  useEffect(() => {
    fetchAccount();
  }, [account]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!visited && remarks.trim() !== "") {
      setError("You can only add remarks after marking as visited.");
      return;
    }

    try {
      const res = await fetch(`/api/linebaccounts/${account}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visited, remarks }),
      });

      const result = await res.json();
      if (res.ok) {
        setSuccessMessage("Update successful. Redirecting...");
        setError(""); // clear any previous errors
        setTimeout(() => {
          window.location.href = `/linebaccounts/${account}`;
        }, 2000); // 2.5 seconds delay
      } else {
        setError(result.error || "Update failed");
        setSuccessMessage("");
      }
    } catch (err) {
      setError("Update failed!");
      setSuccessMessage("");
    }
  };

  if (!accountData) return <p>Loading...</p>;

  return (
    <div className="lineb-details">
      <h2>Line B Accounts Details</h2>
      <h2>Account No. {account}</h2>

      <table className="account-details-table">
        <tbody>
          {Object.entries(accountData).map(([key, value], index) => (
            <tr key={index}>
              <td><strong>{key}</strong></td>
              <td>{typeof value === "boolean" ? (value ? "Yes" : "No") : value}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <form className="update-form" onSubmit={handleSubmit}>
        <div className="visited-checkbox">
          <label>
            <input
              type="checkbox"
              checked={visited}
              onChange={() => setVisited(true)}
            />
            {" "}Visited
          </label>
        </div>

        <div className="remarks-input">
          <label><strong>Remarks:</strong></label>
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            rows="4"
            disabled={!visited}
          />
        </div>

        {error && <p className="error-msg">{error}</p>}
        {successMessage && <p className="success-msg">{successMessage}</p>}

        <button type="submit" className="submit-btn">
          Submit Update
        </button>
      </form>

      <br />
      <button className="back-btn" onClick={() => navigate("/linebaccounts")}>
        ← Back to List
      </button>
    </div>
  );
}
